<style src="./StoredNavigator.scss" lang="scss" scoped></style>
<template>
  <div class="stored-navigator">
    <button
      type="button"
      class="button-paginator"
      @click="goToPreviousPage"
      v-shortkey="['ctrl', 'arrowleft']"
      @shortkey="goToPreviousPage">
      <icon-left-arrow />
    </button>

    <button
      type="button"
      class="button-paginator first-button"
      :class="{'selected-page': actualPage === 0}"
      @click="goToPage(0)"
      v-if="actualPage > 2">
      1
    </button>

    <button
      type="button"
      class="button-paginator"
      :class="{'selected-page': page === actualPage}"
      v-for="(page, pageIdx) in pages"
      :key="pageIdx"
      @click="goToPage(page)">
      {{ page + 1 }}
    </button>

    <button
      type="button"
      class="button-paginator last-button"
      :class="{'selected-page': actualPage === totalPages}"
      @click="goToPage(totalPages)"
      v-if="actualPage < totalPages - 2">
      {{ totalPages + 1 }}
    </button>

    <button
      type="button"
      class="button-paginator"
      @click="goToNextPage"
      v-shortkey="['ctrl', 'arrowright']"
      @shortkey="goToNextPage">
      <icon-right-arrow />
    </button>
  </div>
</template>

<script>
import { IconRightArrow, IconLeftArrow } from '@/components/primitives/icons'

export default {
  name: 'Navigator',
  components: {
    IconRightArrow,
    IconLeftArrow
  },
  props: {
    // domain: {
    //   default: null
    // }
    domain: '',
    totalPages: 0,
    perPage: 0,
    actualPage: 0
  },
  computed: {
    pages () {
      const perPage = []

      const firstPage = 0
      const lastPage = this.totalPages

      if (this.actualPage - 2 >= firstPage) perPage.push(this.actualPage - 2)
      if (this.actualPage - 1 >= firstPage) perPage.push(this.actualPage - 1)
      if (this.actualPage >= 0 && this.actualPage <= this.totalPages) perPage.push(this.actualPage)
      if (this.actualPage + 1 <= lastPage) perPage.push(this.actualPage + 1)
      if (this.actualPage + 2 <= lastPage) perPage.push(this.actualPage + 2)

      return perPage
    }
  },
  methods: {
    goToNextPage () {
      if (this.actualPage + 1 > this.totalPages) return
      const newPage = this.actualPage + 1
      this.$store.commit(`${this.domain}/ACTUAL_PAGE`, newPage)
      this.refreshList()
    },
    goToPreviousPage () {
      if (this.actualPage - 1 < 0) return
      const newPage = this.actualPage - 1
      this.$store.commit(`${this.domain}/ACTUAL_PAGE`, newPage)
      this.refreshList()
    },
    goToPage (pPageNumber) {
      this.$store.commit(`${this.domain}/ACTUAL_PAGE`, pPageNumber)
      this.refreshList()
    },
    refreshList () {
      this.$emit('refreshList')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/paginator/stored-navigator/StoredNavigator.vue